module.exports = __webpack_public_path__ + "img/14.685cc09a.jpg";